import { connect } from 'react-redux';
import * as apiActions from '../../redux/actions/apiActions';

export default (WrappedComponent) => connect(null, apiActions)(WrappedComponent);
